import { FC, memo, useCallback, useState } from "react";
import { StyledNav, StyledNavigation, StyledNavigationNav, StyledSandwitchIcon, StyledSupportDesktop, StyledSupportMobile } from "./Navigation.styled";

import { Menu } from "#/molecules";
import { NavigationProps } from "./Navigation.interface";
import { PhotoplanLogo } from "#/atoms";

const Navigation: FC<NavigationProps> = ({ menus, onLogout, support, orderOfferCount, orderWithOuttakesCount, unmaintainedOrdersCount, unpaidInvoicesCount }) => {
  const [mobileShowMenu, toggleMobileShowMenu] = useState(false);

  const handleSandwichClick = useCallback(() => {
    toggleMobileShowMenu(!mobileShowMenu)
  }, [mobileShowMenu]);

  const handleSupportClick = useCallback(() => {
    if (!support?.onClick) {
      return;
    }
    
    support.onClick()
    toggleMobileShowMenu(!mobileShowMenu)
  }, [mobileShowMenu]);

  const getNotificationforItem = (id: string, defaulNoti: string | undefined) =>
  {
    switch(id) {
      case 'orders':
        return unmaintainedOrdersCount;
      case 'notifications':
        return orderWithOuttakesCount;
      case 'invoices':
        return unpaidInvoicesCount;
      case 'order-offers':
        return orderOfferCount;
      default:
        return defaulNoti;
    }
  }

  return (
    <StyledNavigation>
      <PhotoplanLogo width="200px" isWhite={true} />
      <StyledNav>
        <StyledSandwitchIcon onClick={handleSandwichClick}><span /></StyledSandwitchIcon>
        <StyledNavigationNav mobileShow={mobileShowMenu}>
          {menus.map((menuProps) => (
            <Menu
              key={menuProps.id}
              {...menuProps}
              notification={getNotificationforItem(menuProps.id, menuProps.notification)}
              onLogout={onLogout}
              onClick={handleSandwichClick}
            />
          ))}
          {support && (
            <StyledSupportMobile>
              <Menu {...support} onClick={handleSupportClick} />
            </StyledSupportMobile>
          )}
        </StyledNavigationNav>
      </StyledNav>
      
      {support && <StyledSupportDesktop><Menu {...support} /></StyledSupportDesktop>}
    </StyledNavigation>
  );
}

export default memo(Navigation);
